import { format } from "date-fns";
import { FilterOption } from "shared/components/Filter";

const date = new Date();
const startOfCurrentPeriod = date;
startOfCurrentPeriod.setDate(date.getDate() - 6);

const formattedDate = format(startOfCurrentPeriod, "dd MMM");

export const periodOptions: FilterOption[] = [
  {
    label: `Past week (${formattedDate} - Today)`,
    value: "week",
  },
];
